export enum Role {
    Priest = 1,
    Servant = 2
}
